<ion-content class="edit-user">
  <ng-container>
    <app-header [title]="'Edit Report Information '"></app-header>
      <div class="loading-container" style="padding-top:15%;" *ngIf="!loading">
        <ion-spinner></ion-spinner>
    </div>
    <ion-grid>
      <ion-row class="user-form">
        <ion-grid *ngIf="webReport!=null">
          <ion-row>
            <ion-col>
              <ion-label>Short Name</ion-label>
              <div>
                <ion-input
                  type="text"
                  [(ngModel)]="webReport.shortName"
                  placeholder="Enter short name"
                  class="ion-text-left color-light"
                ></ion-input>
              </div>
            </ion-col>
             <ion-col>
              <ion-label>Display Width</ion-label>
              <div>
                <ion-input
                  type="text"
                  [(ngModel)]="webReport.displayWidth"
                  placeholder="Enter short name"
                  class="ion-text-left color-light"
                ></ion-input>
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-label><span>Report Type</span></ion-label>
              <ion-select
                interface="popover"
                placeholder="Select Report"
                [(ngModel)]="webReport.reportType"
              >
                <ion-select-option value="query">Select Query</ion-select-option>
                <ion-select-option value="link">Link to Another Page</ion-select-option>
              </ion-select>
            </ion-col>
         
              <ion-col>
              <ion-label><span>Access Level</span></ion-label>
              <ion-select
                [(ngModel)]="webReport.accessLevel"
                interface="popover"
                placeholder="Select User Type"
                (ionChange)="selectUserType($event)"
              >
                <ion-select-option value="admin">Admin Only</ion-select-option>
                <ion-select-option value="user">Customer/User</ion-select-option>
                <ion-select-option value="int_user"
                  >Internal User</ion-select-option
                >
              </ion-select>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-label><span>Target</span></ion-label>
                <ion-textarea 
                   autoGrow="false"
                    [(ngModel)]="webReport.apP_TARGET"
                    placeholder="Enter target"
                    class="fixed-textarea"
                ></ion-textarea>
            </ion-col> 
             <ion-col>
              <ion-label>Description</ion-label>
              <div>
                <ion-textarea 
                  autoGrow="false"
                  [(ngModel)]="webReport.description"
                  placeholder="Enter description"
                  class="fixed-textarea"
                ></ion-textarea>
              </div>
            </ion-col>
           
          </ion-row> 
        <ion-row >
            
              <ion-col>
                <ion-label>Category</ion-label>

                <div>
                <span class="helper-text">  Select one from the list or enter a new category</span>
                  <ion-select
                    interface="popover"
                    placeholder="Select category"
                    [(ngModel)]="webReport.category"
                    (ionChange)="onCategoryChange($event)"
                  >
                    <ion-select-option value="new">➕ Add new category</ion-select-option>
                    <ion-select-option *ngFor="let category of categories" [value]="category">
                      {{ category }}
                    </ion-select-option>
                  </ion-select>

                  <ion-input
                    type="text"
                    [(ngModel)]="categoryInput"
                    placeholder="Enter new category"
                    [hidden]="webReport.category !== 'new'"
                    class="ion-text-left color-light"
                  ></ion-input>
                </div>
              </ion-col>
          <ion-col>
              <ion-label>Sum Column</ion-label>
              <div>
                <ion-input
                  type="text"
                  [(ngModel)]="webReport.sumCol"
                  placeholder="Enter short name"
                  class="ion-text-left color-light"
                ></ion-input>
              </div>
               <ion-item no-lines>
                <ion-checkbox
                  [(ngModel)]="webReport.apP_ACTIVE"
                  slot="start"
                ></ion-checkbox>
                <ion-label>Active</ion-label>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col></ion-col>
            <ion-col size="auto">
              <ion-button
                color="gallaghergreen"
                (click)="saveWebReport()"
                class="btn-box-shadow btn-margin"
                ><span>Submit</span></ion-button
              >
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-row>
    </ion-grid>
        <ion-row>
          <div class="table-row">
            <ngx-datatable
              class="bootstrap"
              [rows]="webReportUsers"
              [rowHeight]="50"
              [sortType]="'multi'"
              [headerHeight]="50"
              [footerHeight]="50"
              [columnMode]="'force'"
              [scrollbarH]="false"
            >
             <ngx-datatable-column name="Login" prop="webLogin">
              <ng-template ngx-datatable-cell-template let-value="value">
                {{ value }}
              </ng-template>
            </ngx-datatable-column>
              <ngx-datatable-column name="Name" prop="fname">
              <ng-template ngx-datatable-cell-template let-value="value" let-row="row">
                {{ row.fname }} {{ row.lname }}
              </ng-template>
            </ngx-datatable-column>
              <ngx-datatable-column name="User Type" prop="userType">
              <ng-template ngx-datatable-cell-template let-value="value">
                {{ value }}
              </ng-template>
            </ngx-datatable-column>
              <ngx-datatable-column name="Customer" prop="customerCode">
              <ng-template ngx-datatable-cell-template let-value="value">
                {{ value }}
              </ng-template>
            </ngx-datatable-column>

            </ngx-datatable>
          </div>
        </ion-row>
   
    <div class="table-container" style="margin-top:20px">
  <table class="custom-table">
    <thead>
      <tr class="tableHeader">
        <th colspan="2" style="text-align: center;">Field Help</th>
      </tr>
    </thead>
    <tbody>
      <tr class="tableDetail">
        <td><b>Category</b></td>
        <td>
          This is used to group the reports on the user selection page. Any text may be entered.
          If the category is not available from the selection list then just add a new one.
        </td>
      </tr>
      <tr class="tableDetail">
        <td><b>Report Type</b></td>
        <td>
          There are two types of reports supported: "Link to Another Page" or a "Select Query" which returns
          rows from the database. Which type of report you select will determine what needs to be put in the TARGET field.
        </td>
      </tr>
      <tr class="tableDetail">
        <td><b>Target</b></td>
        <td>
          If the <b>Report Type</b> is "Link to Another Page", enter the page name in the TARGET field.
          By default, customer reports are stored in the CustomReports directory. If the report is located there,
          just enter the report name. <br><b>EG.</b> report1.asp
          <p>
          If the <b>Report Type</b> is "Select Query", enter the SQL query in this field.
          <br><br>
          <b>Some Notes on Queries</b>
          <ul>
            <li>No double quotes in the query; convert to single quotes if needed.</li>
            <li>Getting the current system date: <b>GetDate()</b></li>
            <li>To add or subtract dates: <b>(GetDate() - 7)</b> returns a date one week before today.</li>
          </ul>
        </td>
      </tr>
      <tr class="tableDetail">
        <td><b>Access Level</b></td>
        <td>
          Access to the reports can be restricted by user type. If just Administrator Access is desired, select "Admin Only".
          If the report is to be accessed by other internal users, select "Internal User".
          <p><b>Note:</b> Administrators will be able to see all reports.</p>
        </td>
      </tr>
      <tr class="tableDetail">
        <td><b>Display Width</b></td>
        <td>
          Applies only if the REPORT TYPE is "Select Query". Sets how wide the resulting table is.
          <p><b>Some Common Values</b></p>
          <ul>
            <li>100% - table width = user's screen width</li>
            <li>650 - approx. width of a printed page</li>
          </ul>
        </td>
      </tr>
      <tr class="tableDetail">
        <td><b>Sum Column</b></td>
        <td>
          Applies only if REPORT TYPE is "Select Query". Allows summing one column of returned data.
          Indicate the column to sum; leave blank if none.
        </td>
      </tr>
      <tr class="tableDetail">
        <td><b>Active</b></td>
        <td>
          Use the Active column to control the visibility of each report.
        </td>
      </tr>
    </tbody>
  </table>
</div>

  </ng-container>
</ion-content>
